import 'stylesheets/application.scss'
import 'stylesheets/react-slick.scss'
import 'stylesheets/blog-carousel.scss'
import 'utils/sentry'

import ReactOnRails from 'react-on-rails'

import BlogHome from 'pages/_serverRendered/Blog/Home'
import BlogPost from 'pages/_serverRendered/Blog/BlogPost'
import CmsPage from 'pages/_serverRendered/CmsPage'
import CmsPageV2 from 'pages/_serverRendered/CmsPageV2'
import ContractorsNearMe from 'pages/_serverRendered/landing/ContractorsNearMe'
import Homepage from 'pages/_serverRendered/Homepage'
import HomepageV2212 from 'pages/_serverRendered/HomepageV2212'
import HomeSearch from 'pages/_serverRendered/HomeSearch'
import HomeValuesNearMe from 'pages/_serverRendered/landing/HomeValuesNearMe'
import Learn from 'pages/_serverRendered/Learn'
import Privacy from 'pages/_serverRendered/Privacy'
import ProjectCaseStudy from 'pages/_serverRendered/ProjectCaseStudy'
import ProjectPricing from 'pages/_serverRendered/ProjectPricing'
import PropertyPotential from 'pages/_serverRendered/landing/PropertyPotential'
import PublicCity from 'pages/_serverRendered/Public/City'
import PublicNeighborhood from 'pages/_serverRendered/PublicNeighborhood'
import PublicProperty from 'pages/_serverRendered/PublicProperty'
import PublicState from 'pages/_serverRendered/Public/State'
import RateTable from 'pages/_serverRendered/RateTable'
import Terms from 'pages/_serverRendered/Terms'
import Unavailable from 'pages/_serverRendered/Unavailable'
import VendorContract from 'pages/_serverRendered/VendorContract'
import VendorSignup from 'pages/_serverRendered/VendorSignup'
import EventSignup from 'pages/_serverRendered/EventSignup'
import AeEventSignup from 'pages/_serverRendered/AeEventSignup'
import VendorSiteVisit from 'pages/_serverRendered/VendorSiteVisit'
import HomeownerSiteVisit from 'pages/_serverRendered/HomeownerSiteVisit'

ReactOnRails.register({
  BlogHome,
  BlogPost,
  CmsPage,
  CmsPageV2,
  ContractorsNearMe,
  Homepage,
  HomepageV2212,
  HomeSearch,
  HomeValuesNearMe,
  Learn,
  Privacy,
  ProjectCaseStudy,
  ProjectPricing,
  PropertyPotential,
  PublicCity,
  PublicNeighborhood,
  PublicProperty,
  PublicState,
  RateTable,
  Terms,
  Unavailable,
  VendorContract,
  VendorSignup,
  VendorSiteVisit,
  HomeownerSiteVisit,
  EventSignup,
  AeEventSignup,
})
